import "../sass/child-styles.scss"

import ChildThemeAnimations from "./modules/ChildThemeAnimations";
import DynamicSiteLogo from "./modules/./DynamicSiteLogo";
import LightboxModal from "./modules/LightboxModal";

const childThemeAnimations = new ChildThemeAnimations();
const dynamicSiteLogo = new DynamicSiteLogo();
const lightboxModal = new LightboxModal();